import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { logout } from '../../services/authService';
import '../../assets/styles/Header.css';

const Header: React.FC = () => {
  const navigate = useNavigate();
  
  const handleLogout = async () => {
    try {
      // Usar el servicio de autenticación para cerrar sesión
      await logout();
      // Redireccionar al login
      navigate('/login');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
      // En caso de error, igual dirigimos al login, pero mostramos un error en consola
      navigate('/login');
    }
  };

  return (
    <header className="header">
      <div className="logo">
        <Link to="/">Reassist</Link>
      </div>
      <nav>
        <ul className="nav-menu">
          <li>
            <Link to="/beneficiaries">Beneficiarios</Link>
          </li>
          <li>
            <Link to="/assistances">Asistencias</Link>
          </li>
          <li>
            <Link to="/users">Usuarios</Link>
          </li>
          <li>
            <Link to="/profile">
              <FontAwesomeIcon icon={faUser} /> Mi Perfil
            </Link>
          </li>
          <li>
            <button onClick={handleLogout} className="logout-btn">
              <FontAwesomeIcon icon={faSignOutAlt} /> Cerrar Sesión
            </button>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header; 